module.exports = __webpack_public_path__ + "static/media/smile.0205a3f1.svg";